var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCollection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: "false",
    preserveAspectRatio: "xMidYMid meet",
    style: {
      willChange: "transform"
    },
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 6v4H6V6H26m0-2H6A2 2 0 0 0 4 6v4a2 2 0 0 0 2 2H26a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zM10 16V26H6V16h4m0-2H6a2 2 0 0 0-2 2V26a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2V16a2 2 0 0 0-2-2zM26 16V26H16V16H26m0-2H16a2 2 0 0 0-2 2V26a2 2 0 0 0 2 2H26a2 2 0 0 0 2-2V16a2 2 0 0 0-2-2z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollection);
export default __webpack_public_path__ + "static/media/collection.e0c59506fa35526ab65af5bc7dfee088.svg";
export { ForwardRef as ReactComponent };